export default function phoneNumberInUsFormat(e164number: string): string {
  if (e164number.startsWith("+1") === false) return e164number
  const local = e164number.replace("+1", "")
  if (local.length !== 10) return e164number

  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6, 10)}`
}
